import { c as _c } from "react/compiler-runtime";
import type React from 'react';
const CardFootnote = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <p className="mt-6 text-center text-body-1 text-tertiary">{children}</p>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default CardFootnote;